module.exports = __webpack_public_path__ + "static/media/check.92e0a36f.svg";